import { EditCtrl } from "../Editor"

export default class MeradloEditCtrl extends EditCtrl {
  
  static $inject = ["item", "saveHandler", "stavMeradlaSource"];

  constructor(item, saveHandler, stavMeradlaSource){
    super(item, saveHandler)
    this.stavMeradlaSource = stavMeradlaSource;
    this.stavMeradlaSource.load();
  }



}



// WEBPACK FOOTER //
// ./src/Meradlo/MeradloEditCtrl.js